import { render, staticRenderFns } from "./FirmwideEmissionByScopeForThreeYears.vue?vue&type=template&id=7efbebb7&scoped=true"
import script from "./FirmwideEmissionByScopeForThreeYears.vue?vue&type=script&lang=js"
export * from "./FirmwideEmissionByScopeForThreeYears.vue?vue&type=script&lang=js"
import style0 from "./FirmwideEmissionByScopeForThreeYears.vue?vue&type=style&index=0&id=7efbebb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efbebb7",
  null
  
)

export default component.exports